module.exports = __webpack_public_path__ + "static/media/ordner_passive.090b7a7a.jpg";